import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  rotas: [],
  tags: [],
  rotaSelecionada: {},
  rotaUse: {},
  gruposRotas: {}
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
